<ng-container *ngIf="viewStatus === ViewStatus.LOADING">
  <app-shimmer-view viewType="form"></app-shimmer-view>
</ng-container>

<div class="list" *ngIf="viewStatus === ViewStatus.READY && quote">
  <div class="item first-item">
    <div class="line w-50">
      <span class="title">
        <i class="ti ti-user"></i>
        {{ "Customer" | translate }}
      </span>
      <span class="desc">
        {{ getCustomerName() }}
      </span>
    </div>
    <div class="line w-50" *ngIf="formattedLocation">
      <span class="title">
        <i class="ti ti-map-pin"></i>
        {{ 'Location' | translate }}
      </span>
      <div class="desc">{{ formattedLocation }}</div>
    </div>
  </div>

  <div class="item">
    <div class="line w-50">
      <span class="title">
        <i class="ti ti-moneybag"></i>
        {{ 'Declared Amount' | translate }}
      </span>
      <span class="desc">
        {{ AmountUtils.formatAmount(quote.declaredAmount, 'EUR') }}
      </span>
    </div>
    <div class="line w-50">
      <span class="title">
        <i class="ti ti-calendar"></i>
        {{ 'Created At' | translate }}
      </span>
      <span class="desc">
        {{ quote.createdAt | date:'dd/MM/yyyy':'':'en-US' }}
        <span class="time">{{quote.createdAt | date:'HH:mm':'':'en-US' }}</span>
        <span class="created-by" *ngIf="quote.createdByName"> by {{ quote.createdByName }}</span>
      </span>
    </div>
  </div>

  <div class="item">
    <div class="line">
      <span class="title">
        <i class="ti ti-building"></i>
        {{ 'Services Included' | translate }}
      </span>
      <div class="services-grid">
        <div class="service-badge" [ngClass]="quote.accommodationIncluded ? 'included' : 'not-included'">
          <i class="ti service-icon" [class]="quote.accommodationIncluded ? 'ti-check' : 'ti-x'"></i>
          <span>{{ 'Accommodation' | translate }}</span>
        </div>
        <div class="service-badge" [ngClass]="quote.flightIncluded ? 'included' : 'not-included'">
          <i class="ti service-icon" [class]="quote.flightIncluded ? 'ti-check' : 'ti-x'"></i>
          <span>{{ 'Flight' | translate }}</span>
        </div>
        <div class="service-badge" [ngClass]="quote.isFinanceable ? 'included' : 'not-included'">
          <i class="ti service-icon" [class]="quote.isFinanceable ? 'ti-check' : 'ti-x'"></i>
          <span>{{ 'Financeable' | translate }}</span>
        </div>
        <div class="service-badge" [ngClass]="quote.hasTransportToClinic ? 'included' : 'not-included'">
          <i class="ti service-icon" [class]="quote.hasTransportToClinic ? 'ti-check' : 'ti-x'"></i>
          <span>{{ 'Transport to Clinic' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="item" *ngIf="quote.pdf" [ngClass]="{ 'no-border': !quote.internalNote }">
    <div class="line">
      <span class="title">
        <i class="ti ti-file-text"></i>
        {{ 'Document' | translate }}
      </span>
      <span class="desc">
        <a href="#" (click)="openPdfViewer(quote.pdf); $event.preventDefault()" class="pdf-link">
          {{ 'View PDF' | translate }}
        </a>
      </span>
    </div>
  </div>

  <div class="images">
    <div class="line">
      <div class="notes-header">
        <span class="title">
          <i class="ti ti-notes"></i>
          {{ 'Internal Notes' | translate }}
        </span>
        <div class="notes-actions">
          <button *ngIf="!isEditingNote" class="btn-edit" (click)="toggleEditNote()" type="button">
            <i class="ti ti-edit"></i>
            {{ 'Edit' | translate }}
          </button>
          <ng-container *ngIf="isEditingNote">
            <button class="btn-cancel" (click)="cancelEditNote()" type="button">
              <i class="ti ti-x"></i>
              {{ 'Cancel' | translate }}
            </button>
            <button class="btn-save" (click)="saveNote()" type="button">
              <i class="ti ti-check"></i>
              {{ 'Save' | translate }}
            </button>
          </ng-container>
        </div>
      </div>
      <div class="notes-content" *ngIf="!isEditingNote">{{ quote.internalNote ?? 'No internal notes' }}</div>
      <textarea *ngIf="isEditingNote" class="notes-textarea" [(ngModel)]="editedNote" rows="5"
        placeholder="{{ 'Enter internal notes...' | translate }}"></textarea>
    </div>
  </div>
</div>
